import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import {
  JoinPossibleCheckByPcode,
  ResponseDataType,
  TermsListSpace,
  UIInfoSpace,
} from 'src/types/api'
import { AxiosError } from 'axios'
import { fetch } from 'src/service/api/fetcher'
import { CMDTYPES } from 'src/types/cmdtype'
import { gri } from 'src/service/utils'
import { captureTermsError } from 'src/service/utils/sentry/validation'
import { monitoredReplace } from 'src/service/utils/sentry/navigation'

export function useCustomQuery<U>(
  option: UseQueryOptions<ResponseDataType<U>, AxiosError>,
): UseQueryResult<ResponseDataType<U>, AxiosError> {
  return useQuery(option)
}

export const uiInfoQueryOption = (
  pCode: string,
  slotNo?: number | null,
): Pick<
  UseQueryOptions<ResponseDataType<UIInfoSpace.Response>, AxiosError>,
  'queryFn' | 'queryKey'
> => ({
  queryKey: ['ui_info_items', pCode, slotNo ?? null],
  queryFn: () =>
    fetch
      .post<UIInfoSpace.Request, UIInfoSpace.Response>(CMDTYPES.UI_INFO_API, {
        PCode: pCode,
        ...(slotNo != null ? { SlotNo: slotNo } : {}),
      })
      .then((res) => {
        if (res.Body.ButtonMsgAfter === '') {
          alert('제휴사 오류입니다.')
          monitoredReplace(
            `${window.location.origin}/rop01/default/${gri()}/0`,
            'handleMoveToDefaultJoinPage',
          )
        }
        return res
      }),
})

export const termsListQueryOption = (): Pick<
  UseQueryOptions<ResponseDataType<TermsListSpace.Response>, AxiosError>,
  'queryFn' | 'queryKey'
> => ({
  queryKey: ['terms_contents'],
  queryFn: () =>
    fetch
      .post<TermsListSpace.Request, TermsListSpace.Response>(CMDTYPES.TERMS_LIST_API, {})
      .then((res) => {
        captureTermsError(res.Body)
        return res
      }),
})

export const joinCHeckByPcodeQueryOption = (
  pcode: string,
): Pick<
  UseQueryOptions<ResponseDataType<JoinPossibleCheckByPcode.Response>, AxiosError>,
  'queryFn' | 'queryKey'
> => ({
  queryKey: ['join_possible_check_by_pcode', `${pcode}`],
  queryFn: () =>
    fetch.post<JoinPossibleCheckByPcode.Request, JoinPossibleCheckByPcode.Response>(
      CMDTYPES.JOIN_POSSIBLE_CHECK_BY_PCODE,
      { Pcode: pcode },
    ),
})
